var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-framework";
import { BaseTemplate } from "../../../styles/client/templates/base-template";
import { Router } from "aurelia-router";
import { I18N } from "aurelia-i18n";
import { DialogClientService } from "../../../services/basics/dialog-client.service";
import { ClientLotteryClientService } from "../../../services/modules/client/client-lottery-client-service";
import { Client } from "../client/client";
import { TokenClient } from "../../../services/authentication/token-client.service";
import { IFramePostMessages } from "../../../models/modules/lotteryplatform-client.models";
import { RouterConstants } from "../../../configuration/router.constants";
import * as Enumerable from "linq";
import { TemplateNames } from "../../../models/modules/lotteryplatofrm.models";
require('./core-client-overlay.scss');
var ClientOverlay = /** @class */ (function (_super) {
    __extends(ClientOverlay, _super);
    function ClientOverlay(client, router, lotteryClientService, i18N, dialogClientService, tokenClient) {
        var _this = _super.call(this, router, i18N, lotteryClientService, dialogClientService, tokenClient) || this;
        _this.client = client;
        _this.nextLotteryIndex = 0;
        return _this;
    }
    ClientOverlay.prototype.attached = function () {
        var _this = this;
        _super.prototype.attached.call(this);
        this.clientLotteryClientService.getOverlayFeaturedKeys().then(function (list) {
            var carousel = Enumerable.from(list);
            var lotteriesFeatured = carousel.select(function (x) { return _this.getLotteryByKey(_this.lotteries, x); }).where(function (x) { return x != null; }).toArray();
            var func = function () {
                if (lotteriesFeatured) {
                    _this.currentLottery = lotteriesFeatured[_this.nextLotteryIndex];
                    _this.nextLotteryIndex = _this.nextLotteryIndex + 1;
                    if (_this.nextLotteryIndex == lotteriesFeatured.length) {
                        _this.nextLotteryIndex = 0;
                    }
                }
            };
            func();
            _this._interval = setInterval(func, 7500);
        });
    };
    ClientOverlay.prototype.detached = function () {
        _super.prototype.detached.call(this);
        if (!this._interval)
            clearInterval(this._interval);
    };
    ClientOverlay.prototype.shouldSendHeightToClient = function () {
        return true;
    };
    Object.defineProperty(ClientOverlay.prototype, "showBottomNavigation", {
        get: function () {
            return this.tokenClient.user && this.tokenClient.user.templateName != TemplateNames.Template11;
        },
        enumerable: false,
        configurable: true
    });
    ClientOverlay.prototype.toggleOverlay = function () {
        var _this = this;
        this.showOverlay = !this.showOverlay;
        if (this.showOverlayDelayedHandle) {
            clearTimeout(this.showOverlayDelayedHandle);
        }
        if (!this.showOverlay) {
            this.showOverlayDelayedHandle = setTimeout(function () {
                _this.showOverlayDelayed = false;
            }, 900);
        }
        else {
            this.showOverlayDelayed = true;
        }
        this.notifyOverlayStateChanged();
    };
    ClientOverlay.prototype.openOverlay = function () {
        this.showOverlay = true;
        this.notifyOverlayStateChanged();
    };
    ClientOverlay.prototype.notifyOverlayStateChanged = function () {
        window.parent.postMessage({
            event: IFramePostMessages.onOverlayVisibilityChange,
            detail: {
                isVisible: this.showOverlay
            }
        }, "*");
    };
    ClientOverlay.prototype.getRouterView = function () {
        return ".page-client-overlay";
    };
    ClientOverlay.prototype.navigateToLottery = function (lottery) {
        if (!this.tokenClient.isPreview) {
            var key = this.getLotteryKey(lottery.lotteryName);
            this.router.navigateToRoute(RouterConstants.RouteNames.Lottery, {
                lotteryId: lottery.lotteryId,
                key: key,
                brandLotteryId: lottery.brandLotteryId
            }, { replace: true });
        }
    };
    ClientOverlay.prototype.navigateToLobby = function () {
        if (!this.tokenClient.isPreview) {
            this.router.navigateToRoute(RouterConstants.RouteNames.Lobby, {}, { replace: true });
        }
    };
    ClientOverlay = __decorate([
        autoinject,
        __metadata("design:paramtypes", [Client, Router, ClientLotteryClientService, I18N, DialogClientService, TokenClient])
    ], ClientOverlay);
    return ClientOverlay;
}(BaseTemplate));
export { ClientOverlay };
